/**
 * Distance annotation geometry properties — registration and getters.
 *
 * Properties registered here:
 * - distance_points (JSON, PROJECT_GLOBAL) — Array<{position: {x,y,z}, pointCloudId?: string}>
 */

import { PropertyType, PropertyValueType } from '../../types';
import { propertyRegistry } from '../../PropertyRegistry';
import { getGlobalPropertyService } from '../../reactive/globalPropertyService';
import { TypedJsonProperty } from '../../reactive/TypedJsonProperty';

export type AnnotationPoint = { position: { x: number; y: number; z: number }; pointCloudId?: string | null };

export function registerDistanceGeometryProperties() {
  if (!propertyRegistry.isRegistered('distance_points')) {
    propertyRegistry.register({
      type: PropertyType.PROJECT_GLOBAL,
      identifier: 'distance_points',
      name: 'Points',
      valueType: PropertyValueType.JSON,
      defaultValue: '[]',
      annotationTypes: [],
    });
  }
}

registerDistanceGeometryProperties();

const distancePointsCache = new Map<string, TypedJsonProperty<AnnotationPoint[]>>();

export function getDistancePointsProperty(annotationId: string): TypedJsonProperty<AnnotationPoint[]> {
  const cached = distancePointsCache.get(annotationId);
  if (cached && !cached.isDestroyed) return cached;

  const service = getGlobalPropertyService();
  const raw = service.getProperty('distance_points', annotationId, PropertyType.PROJECT_GLOBAL);
  const typed = new TypedJsonProperty<AnnotationPoint[]>(raw);
  distancePointsCache.set(annotationId, typed);
  return typed;
}
